import type { Config } from '@schibsted-svp/web-player';

/**
 * `titleOverride` only applies to the asset the player was configured with
 * (`id` / `asset` in the player config), never to play-next assets.
 */
export const resolveTitleOverride = (
  rawConfig: Pick<Config, 'id' | 'asset'>,
  assetId: number | undefined,
  titleOverride: string | undefined
) => {
  if (!titleOverride || assetId === undefined) {
    return undefined;
  }

  const configuredAssetId = rawConfig.id ?? rawConfig.asset?.id;

  return configuredAssetId === assetId ? titleOverride : undefined;
};
